
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1b522_im8v7_5"
};
  